import { PropTypes } from 'react';
import Icon from 'noc/components/icon';
import classNames from 'classnames';


const TableCol = ({
    children,
    name,
    isSort,
    dataSort,
    sortOrders,
    tabData
}) => {
    const isColumnExists = tabData.QueueViewGrid.Columns.find(x => x.Name === sortOrders[0].ColumnName);
    const sortColumn = isColumnExists ? sortOrders[0].ColumnName : sortOrders[1].ColumnName;
    const sortDirection = isColumnExists ? sortOrders[0].ColumnOrderString : sortOrders[1].ColumnOrderString;
    const className = classNames({
        'cn-table__hdr': true,
        'cn-table__hdr--sorted': name === sortColumn
    });

    const colClassName = classNames({
        'cn-table__hdr__text': true,
        'cn-table__hdr__textWrap': children === 'HD Region' || children === 'HOP (EXT)' || children === 'HOP (INT)' || children === 'Origin Of Call' || children === 'Ticket Source'
    });

    return (

        <th
            className={className}
            onClick={() => {
                isSort && dataSort(name, sortDirection);
            }}
        >
            <span className={colClassName}>{children}</span>
            {name === sortColumn && isColumnExists.IsSort === true && <Icon
                type="cn-icon--sorted"
                icon={sortDirection === 'Asc'
                    ? 'icon-arrow-up'
                    : 'icon-arrow-down'}
            />
            }
        </th>
    );
};

TableCol.propTypes = {
    children: PropTypes.node,
    dataSort: PropTypes.func,
    sortOrders: PropTypes.arrayOf(PropTypes.object),
    name: PropTypes.string,
    isSort: PropTypes.bool
};

export default TableCol;



// WEBPACK FOOTER //
// ./app/components/table/col.jsx